interface BorderProps {
  className?: string;
  borderWidth?: number;
}

export function Border({ className, borderWidth = 2 }: BorderProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      className={className}
    >
      <defs>
        <linearGradient
          id="border_svg__a"
          x1="0%"
          y1="50%"
          x2="100%"
          y2="50%"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0%" style={{ stopColor: "#7656D9", stopOpacity: 1 }} />
          <stop
            offset="100%"
            style={{ stopColor: "#DE3F71", stopOpacity: 1 }}
          />
        </linearGradient>
      </defs>
      <rect
        width={`calc(100% - ${borderWidth}px)`}
        height={`calc(100% - ${borderWidth}px)`}
        x={borderWidth / 2}
        y={borderWidth / 2}
        fill="none"
        stroke="url(#border_svg__a)"
        strokeWidth={borderWidth}
        rx="22"
        ry="22"
      ></rect>
    </svg>
  );
}
